interface ColorValues {
  'clr-black': string;
  'clr-white': string;
  'clr-tooltip-text': string;
  'clr-btn-hover-bg': string;
  'clr-body-bg': string;
  'clr-container-bg': string;
  'clr-title': string;
  'clr-subtitle': string;
  'clr-border-grey-100': string;
  'clr-general-secondary': string;
  'clr-icon-color': string;
  'clr-general-description': string;
  'clr-danger-bg': string;
  'clr-primary-error': string;
  'clr-error-100': string;
  'clr-general-dark-grey': string;
  'clr-grey-100': string;
  'clr-general-btn-hover': string;
  'clr-info-bg': string;
  'clr-info-toast-text': string;
  'clr-green-100': string;
  'clr-green-200': string;
  'clr-green': string;
  'clr-red': string;
  'clr-yellow': string;
  'clr-light-blue': string;
  'clr-blue': string;
  'clr-beige': string;
  'clr-light-green': string;
  'clr-purple': string;
  'clr-default-hover': string;
  'clr-yellow-100': string;
  'clr-green-300': string;
  'clr-lightblue-100': string;
  'clr-lightgreen-100': string;
  'clr-blue-100': string;
  'clr-beige-100': string;
  'clr-red-100': string;
  'clr-purple-100': string;
  'clr-yellow-200': string;
  'clr-notification-title': string;
  'clr-error-200': string;
  'clr-shadow': string;
  'clr-table-shadow': string;
  'border-green': string;
  'border-light-blue': string;
  'border-light-green': string;
  'border-yellow': string;
  'border-blue': string;
  'border-beige': string;
  'border-red': string;
  'border-purple': string;
  'border-dark-grey': string;
  'tag-blue': string;
  'tag-green': string;
  'tag-light-blue': string;
  'tag-light-green': string;
  'tag-yellow': string;
  'tag-beige': string;
  'tag-red': string;
  'tag-toast-error': string;
  'tag-purple': string;
  'tag-dark-grey': string;
  'favourite-bg': string;
  'clr-inline-error': string;
  'clr-inline-help': string;
  'clr-inline-warning': string;
  'clr-field-disabled': string;
  'clr-error-border': string;
  'clr-green-400': string;
  'clr-beige-200': string;
  'clr-yellow-300': string;
}

export const themes: Record<'light' | 'dark', ColorValues> = {
  light: {
    'clr-inline-error': '217, 9, 23',
    'clr-inline-help': '77, 77, 77',
    'clr-inline-warning': '211, 125, 7',
    'clr-white': '255, 255, 255',
    'clr-black': '0, 0, 0',
    'clr-tooltip-text': '255, 255, 255',
    'clr-btn-hover-bg': '246, 246, 246',
    'clr-body-bg': '246, 246, 246',
    'clr-container-bg': '255, 255, 255',
    'clr-title': '21, 23, 32',
    'clr-subtitle': '63, 65, 80',
    'clr-border-grey-100': '227, 227, 227',
    'clr-general-secondary': '15, 152, 131',
    'clr-icon-color': '206, 208, 219',
    'clr-general-description': '110, 112, 122',
    'clr-danger-bg': '228, 2, 25',
    'clr-primary-error': '228, 2, 25',
    'clr-error-100': '231, 76, 60',
    'clr-error-200': '255, 205, 204',
    'clr-general-dark-grey': '21, 23, 32',
    'clr-grey-100': '148, 151, 160',
    'clr-general-btn-hover': '227, 227, 227',
    'clr-green-100': '185, 248, 197',
    'clr-green-200': '38, 96, 27',
    'clr-info-bg': '75, 201, 225',
    'clr-info-toast-text': '21, 23, 32',
    'clr-green': '73, 124, 63',
    'clr-red': '228, 2, 25',
    'clr-yellow': '255, 168, 1',
    'clr-light-blue': '75, 201, 225',
    'clr-blue': '37, 115, 185',
    'clr-beige': '140, 109, 16',
    'clr-light-green': '33, 140, 116',
    'clr-purple': '85, 99, 224',
    'clr-default-hover': '242, 243, 247',
    'clr-yellow-100': '255, 168, 1, 0.2',
    'clr-green-300': '73, 124, 63, 0.2',
    'clr-lightblue-100': '75, 201, 225, 0.2',
    'clr-lightgreen-100': '33, 140, 116, 0.2',
    'clr-blue-100': '37, 115, 185, 0.2',
    'clr-beige-100': '140, 109, 16, 0.2',
    'clr-red-100': '228, 2, 25, 0.2',
    'clr-purple-100': '85, 99, 224, 0.2',
    'clr-yellow-200': '251, 231, 199',
    'clr-notification-title': '21, 23, 32',
    'clr-shadow': '21, 23, 32, 0.15',
    'clr-table-shadow': '0, 0, 0',
    'border-green': '45, 168, 86',
    'border-light-blue': '4, 164, 169',
    'border-light-green': '33, 140, 116',
    'border-yellow': '217, 125, 6',
    'border-blue': '125, 140, 241',
    'border-beige': '151, 151, 12',
    'border-red': '240, 103, 112',
    'border-purple': '184, 125, 209',
    'border-dark-grey': '133, 148, 171',
    'tag-green': '219, 243, 227',
    'tag-light-blue': '218, 243, 243',
    'tag-light-green': '33, 140, 116,0.15',
    'tag-yellow': '247, 233, 215',
    'tag-blue': '217, 221, 244',
    'tag-beige': '246, 246, 218',
    'tag-red': '245, 217, 219',
    'tag-toast-error': '255, 205, 204',
    'tag-purple': '235, 221, 240',
    'tag-dark-grey': '227, 230, 235',
    'favourite-bg': '21, 23, 32',
    'clr-field-disabled': '21, 23, 32, 0.02',
    'clr-error-border': '217, 9, 23',
    'clr-green-400': '5, 129, 47',
    'clr-beige-200': '161, 94, 7',
    'clr-yellow-300': '247, 212, 121',
  },
  dark: {
    'clr-inline-error': '217, 9, 23',
    'clr-inline-help': '148, 151, 160',
    'clr-inline-warning': '211, 125, 7',
    'clr-white': '255, 255, 255',
    'clr-black': '0, 0, 0',
    'clr-tooltip-text': '25, 28, 37',
    'clr-btn-hover-bg': '246, 246, 246',
    'clr-body-bg': '20, 23, 31',
    'clr-container-bg': '25, 28, 37',
    'clr-title': '242, 243, 247',
    'clr-subtitle': '147, 147, 147',
    'clr-border-grey-100': '62, 64, 79',
    'clr-general-secondary': '15, 152, 131',
    'clr-icon-color': '62, 64, 79',
    'clr-general-description': '148, 151, 160',
    'clr-danger-bg': '167, 40, 53',
    'clr-primary-error': '228, 2, 25',
    'clr-error-100': '231, 76, 60',
    'clr-error-200': '255, 205, 204',
    'clr-general-dark-grey': '21, 23, 32',
    'clr-grey-100': '148, 151, 160',
    'clr-general-btn-hover': '227, 227, 227',
    'clr-info-bg': '75, 201, 225',
    'clr-info-toast-text': '255, 255, 255',
    'clr-green-100': '185, 248, 197',
    'clr-green-200': '38, 96, 27',
    'clr-green': '73, 124, 63',
    'clr-red': '228, 2, 25',
    'clr-yellow': '255, 168, 1',
    'clr-light-blue': '75, 201, 225',
    'clr-blue': '37, 115, 185',
    'clr-beige': '140, 109, 16',
    'clr-light-green': '33, 140, 116',
    'clr-purple': '85, 99, 224',
    'clr-default-hover': '256, 256, 256',
    'clr-yellow-100': '255, 168, 1, 0.25',
    'clr-green-300': '73, 124, 63, 0.3',
    'clr-lightblue-100': '75, 201, 225, 0.25',
    'clr-lightgreen-100': '33, 140, 116, 0.3',
    'clr-blue-100': '37, 115, 185, 0.3',
    'clr-beige-100': '140, 109, 16, 0.3',
    'clr-red-100': '228, 2, 25, 0.3',
    'clr-purple-100': '85, 99, 224, 0.3',
    'clr-yellow-200': '251, 231, 199',
    'clr-notification-title': '21, 23, 32',
    'clr-shadow': '0, 0, 0, 0.50',
    'clr-table-shadow': '21, 23, 32',
    'border-green': '32, 121, 62',
    'border-light-blue': '4, 144, 149',
    'border-light-green': '33, 140, 116',
    'border-yellow': '155, 90, 4',
    'border-blue': '64, 87, 234',
    'border-beige': '142, 142, 11',
    'border-red': '208, 21, 33',
    'border-purple': '150, 65, 186',
    'border-dark-grey': '89, 105, 129',
    'tag-green': '30, 82, 47',
    'tag-light-blue': '30, 80, 82',
    'tag-light-green': '33, 140, 116,0.25',
    'tag-yellow': '85, 60, 27',
    'tag-blue': '29, 36, 83',
    'tag-beige': '83, 83, 29',
    'tag-red': '83, 29, 33',
    'tag-toast-error': '83, 29, 33',
    'tag-purple': '68, 35, 82',
    'tag-dark-grey': '49, 59, 73',
    'favourite-bg': '255, 255, 255',
    'clr-field-disabled': '255, 255, 255, 0.02',
    'clr-error-border': '221, 117, 124',
    'clr-green-400': '71, 209, 117',
    'clr-beige-200': '211, 153, 78',
    'clr-yellow-300': '247, 212, 121',
  },
};

// Tinted with the theme colour, so each one is declared per theme colour and per light/dark theme.
interface ThemeColorSurfaces {
  'clr-primary-hover': string;
  'clr-general-hover': string;
  selected: string;
  'selected-hover': string;
  'clr-general-border-hover': string;
}

interface ThemeColorValues {
  primary: string;
  primaryLight: string;
  light: ThemeColorSurfaces;
  dark: ThemeColorSurfaces;
}

// Same palette as the CSI Lawyer web app; `primary` is the default teal.
export const themeColors = {
  primary: {
    primary: '0, 144, 166',
    primaryLight: '77, 177, 193',
    light: {
      'clr-primary-hover': '0, 124, 143',
      'clr-general-hover': '230, 244, 246',
      selected: '214, 238, 241',
      'selected-hover': '198, 231, 236',
      'clr-general-border-hover': '20, 153, 168, 0.45',
    },
    dark: {
      'clr-primary-hover': '0, 124, 143',
      'clr-general-hover': '25, 44, 50',
      selected: '27, 53, 61',
      'selected-hover': '29, 62, 72',
      'clr-general-border-hover': '20, 153, 168, 0.45',
    },
  },
  emeraldGreen: {
    primary: '15, 152, 131',
    primaryLight: '66, 186, 168',
    light: {
      'clr-primary-hover': '10, 103, 89',
      'clr-general-hover': '231, 245, 243',
      selected: '217, 239, 235',
      'selected-hover': '202, 232, 228',
      'clr-general-border-hover': '15, 152, 132, 0.45',
    },
    dark: {
      'clr-primary-hover': '12, 117, 102',
      'clr-general-hover': '24, 45, 50',
      selected: '23, 55, 58',
      'selected-hover': '22, 65, 66',
      'clr-general-border-hover': '15, 152, 132, 0.45',
    },
  },
  pink: {
    primary: '219, 93, 141',
    primaryLight: '244, 149, 185',
    light: {
      'clr-primary-hover': '168, 37, 87',
      'clr-general-hover': '251, 239, 244',
      selected: '249, 229, 237',
      'selected-hover': '247, 219, 230',
      'clr-general-border-hover': '219, 93, 141, 0.45',
    },
    dark: {
      'clr-primary-hover': '197, 44, 102',
      'clr-general-hover': '52, 37, 52',
      selected: '68, 42, 60',
      'selected-hover': '83, 48, 68',
      'clr-general-border-hover': '219, 93, 141, 0.45',
    },
  },
  blue: {
    primary: '73, 194, 217',
    primaryLight: '118, 221, 240',
    light: {
      'clr-primary-hover': '24, 99, 113',
      'clr-general-hover': '237, 249, 251',
      selected: '226, 245, 249',
      'selected-hover': '215, 241, 247',
      'clr-general-border-hover': '39, 161, 185, 0.45',
    },
    dark: {
      'clr-primary-hover': '39, 161, 185',
      'clr-general-hover': '32, 51, 62',
      selected: '36, 64, 77',
      'selected-hover': '39, 78, 91',
      'clr-general-border-hover': '73, 193, 217, 0.45',
    },
  },
  darkBlue: {
    primary: '76, 109, 173',
    primaryLight: '132, 162, 220',
    light: {
      'clr-primary-hover': '57, 84, 129',
      'clr-general-hover': '237, 240, 246',
      selected: '226, 232, 241',
      'selected-hover': '215, 223, 236',
      'clr-general-border-hover': '74, 109, 167, 0.45',
    },
    dark: {
      'clr-primary-hover': '68, 100, 153',
      'clr-general-hover': '32, 39, 55',
      selected: '36, 46, 66',
      'selected-hover': '40, 52, 76',
      'clr-general-border-hover': '74, 109, 167, 0.45',
    },
  },
  purple: {
    primary: '128, 100, 162',
    primaryLight: '193, 168, 223',
    light: {
      'clr-primary-hover': '99, 76, 125',
      'clr-general-hover': '242, 240, 246',
      selected: '235, 230, 240',
      'selected-hover': '227, 221, 234',
      'clr-general-border-hover': '128, 100, 161, 0.45',
    },
    dark: {
      'clr-primary-hover': '112, 86, 142',
      'clr-general-hover': '39, 38, 54',
      selected: '48, 44, 64',
      'selected-hover': '56, 50, 74',
      'clr-general-border-hover': '128, 100, 161, 0.45',
    },
  },
  limeGreen: {
    primary: '127, 192, 75',
    primaryLight: '197, 249, 156',
    light: {
      'clr-primary-hover': '64, 99, 35',
      'clr-general-hover': '242, 249, 237',
      selected: '235, 245, 226',
      'selected-hover': '227, 241, 215',
      'clr-general-border-hover': '105, 163, 57, 0.45',
    },
    dark: {
      'clr-primary-hover': '97, 152, 53',
      'clr-general-hover': '39, 51, 42',
      selected: '47, 64, 45',
      'selected-hover': '56, 77, 48',
      'clr-general-border-hover': '127, 192, 74, 0.45',
    },
  },
} as const satisfies Record<string, ThemeColorValues>;

export type ThemeColorKey = keyof typeof themeColors;

export type ThemeName = keyof typeof themes;

export const resolveThemeColorValues = (color: ThemeColorKey, theme: ThemeName) => ({
  'clr-general-primary': themeColors[color].primary,
  'clr-primary-light': themeColors[color].primaryLight,
  ...themeColors[color][theme],
});

export const breakpoints = {
  xs: '(min-width: 480px)',
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1200px)',
  xxl: '(min-width: 1600px)',
} as const;

export const breakpointsDown = {
  xs: '(max-width: 479px)',
  sm: '(max-width: 575px)',
  md: '(max-width: 767px)',
  lg: '(max-width: 991px)',
  xl: '(max-width: 1199px)',
  xxl: '(max-width: 1599px)',
} as const;

export const spacingValues = [0, 4, 5, 8, 10, 15, 16, 20, 24, 30] as const;

export const fontSizes = [12, 13, 14, 15, 16, 18, 20, 22, 24, 30, 36, 93] as const;

export const fontWeights = [300, 400, 500, 600, 700, 800, 900] as const;

export const lineHeights = [12, 14, 15, 16, 17, 18, 20, 21, 24, 30, 34, 40] as const;

export const displayValues = [
  'none',
  'block',
  'inline',
  'inline-block',
  'flex',
  'grid',
  'contents',
] as const;

export const alignItemsValues = [
  'center',
  'start',
  'end',
  'flex-start',
  'flex-end',
  'baseline',
] as const;

export const justifyContentValues = ['center', 'flex-start', 'flex-end', 'space-between'] as const;

export const flexDirectionValues = ['column', 'row'] as const;

export const textAlignValues = ['left', 'center', 'right'] as const;
